import { FC } from 'react';
import { Stack } from '@mui/material';
import { IUserLogin } from '../../../transcepta-types';
import { Button } from '../../../../ui';

interface IProps {
    userLogin: IUserLogin;
    handleSSOSignIn: () => void;
    handleLogInAgain: () => void;
    /** New card shell: stacked full-width actions. */
    useCardLayout?: boolean;
}

/** Show unless SSO config explicitly disables (missing / true = show). */
function isGoBackExplicitlyDisabled(root?: { showGoBackLink?: unknown } | null): boolean {
    if (!root) {
        return false;
    }
    const v = root.showGoBackLink;
    if (v === false) {
        return true;
    }
    if (typeof v === 'string' && v.trim().toLowerCase() === 'false') {
        return true;
    }
    return false;
}

const SSOForm: FC<IProps> = ({ userLogin, handleSSOSignIn, handleLogInAgain, useCardLayout = false }) => {
    const root = userLogin.accountProfile?.SSOAttributes?.root;
    const showGoBack = !isGoBackExplicitlyDisabled(root);
    const signInLabel = root?.signinLabel ?? 'Sign In using your Login';

    if (useCardLayout) {
        return (
            <Stack spacing={2} sx={{ width: '100%' }}>
                <Button
                    color="primary"
                    variant="default"
                    fullWidth
                    onClick={handleSSOSignIn}
                    testid="sso-sign-in-button"
                >
                    {signInLabel}
                </Button>
                {showGoBack && (
                    <Button
                        type="button"
                        variant="text"
                        fullWidth
                        onClick={handleLogInAgain}
                        testid="login-page-sso-go-back-button"
                        sx={{ textTransform: 'none', justifyContent: 'center', py: 1 }}
                    >
                        Go Back to Transcepta Manager
                    </Button>
                )}
            </Stack>
        );
    }

    return (
        <>
            <Button color="primary" onClick={handleSSOSignIn} testid="sso-sign-in-button">
                {signInLabel}
            </Button>
            {showGoBack && (
                <Button variant="text" onClick={handleLogInAgain} sx={{ mt: 2 }} testid="login-page-sso-go-back-button">
                    Go Back to Transcepta Manager
                </Button>
            )}
        </>
    );
};

export default SSOForm;
